<template>
  <div :class="{
      card: true,
      'collapse-item-card': true,
      'card-inactive': !visible,
      'card-active': visible
    }">
    <div :class="{
        'card-header': true,
        'd-flex justify-content-between align-items-center': true,
        active: visible
      }">
      <h5 class="mb-0 flex-grow-1 cursor-pointer collapse-item-header" @click="click">{{label}}</h5>
      <div class="d-flex justify-content-between align-items-center" v-if="badge || toggle">
        <UpgradeBadge v-if="badge" :targetPlan="badge" tryForFree :class="{
          'mr-2': toggle
        }" />
        <div class="toggle" v-if="toggle">
          <input type="checkbox" class="check" v-model="toggleValue">
          <span class="switch"></span>
          <span class="track"></span>
        </div>
      </div>
    </div>

    <div :class="{
        collapse: true,
        show: visible
      }" :data-parent="parent" v-if="visible">
      <div class="card-body">
        <div class="position-relative">
          <div class="disabled-options" v-if="toggle && !toggleValue">
            <p class="bs cursor-pointer" @click="toggleValue = !toggleValue">Click here to enable this feature</p>
          </div>
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import update from '@/mixins/update'
import UpgradeBadge from '@/components/UpgradeBadge'

import '@/assets/scss/_collapse_item.scss'

export default {
  components: {
    UpgradeBadge
  },
  mixins: [
    update
  ],
  props: {
    noCollapse: Boolean,
    badge: {
      type: String,
      default: ''
    },
    toggle: {
      type: String,
      default: ''
    },
    label: String,
    parent: String,
    highlight: String,
    open: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      itemId: [ Date.now(), Math.random() ].join(''),
      didOpen: false
    }
  },
  computed: {
    ...mapState([ 'collapseItems', 'settings' ]),
    visible: function () {
      const openId = this.collapseItems[this.parent]

      if (!openId && this.open && !this.didOpen) return true

      return openId === this.itemId
    },
    toggleValue: {
      get: function () {
        const val = this.settings.layout[this.toggle]
        if (this.toggle.startsWith('hide')) return !val

        return val
      },
      set: function (value) {
        if (this.toggle.startsWith('hide')) value = !value

        this.$emit('toggle', value)

        this.updateSettings(`layout.${this.toggle}`, value)

        if (value) {
          this.show()
        }

        if (this.toggle === 'search') {
          const marginBottom = value ? '0px' : '15px'

          this.updateAMPTheme('navbar', { marginBottom })
        }
      }
    }
  },
  created: function () {
    if (this.open) {
      this.show()
    }
  },
  methods: {
    show: function () {
      this.didOpen = true

      this.$store.commit('UPDATE_COLLAPSE', {
        parent: this.parent,
        item: this.itemId,
        highlight: this.highlight
      })
    },
    hide: function () {
      if (this.open) this.didOpen = true

      this.$store.commit('UPDATE_COLLAPSE', {
        parent: this.parent,
        item: null,
        highlight: null
      })
    },
    click: function () {
      if (this.noCollapse) return

      if (this.visible) this.hide()
      else this.show()
    }
  }
}
</script>
